import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';

export interface KeyInsightsSection {
  id: number;
  name: string;
  display_title: string;
  short_description?: string;
}

export const getKeyInsightsSections = async () => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/results/key-insights-sections`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.INSIGHTS,
        importance: IMPORTANCE.CRITICAL,
      },
    },
  );
  return response?.sections ?? [];
};

const useKeyInsightsSections = () => {
  const keyInsightsSectionsQuery = useQuery<KeyInsightsSection[]>({
    queryKey: [apiName, 'KeyInsightsSections'],
    queryFn: async () => await getKeyInsightsSections(),
  });

  return keyInsightsSectionsQuery;
};

export default useKeyInsightsSections;
